export default "__VITE_ASSET__$Y$sRqY8__"